import React, { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { isEmail, callAPI, log } from "../../utils/utils";

import PublicPage from "../../elements/PublicPage/PublicPage";
import TextField from "../../elements/TextField/TextField";
import Button from "../../elements/Button/Button";

const PasswordRecoveryRequestPage = () => {

  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  useEffect(() => {

  }, []);

  const [ email, setEmail ] = useState("");
  const [ working, setWorking ] = useState(false);
  const [ emailInvalid, setEmailInvalid ] = useState(false);

  const handleSubmit = (e) => {
    log("handleSubmit");
    e.preventDefault()
    if (!isEmail(email)) {
      setEmailInvalid(true);
      return;
    }

    setWorking(true);
    setEmailInvalid(false);

    callAPI("recovery/request", "POST", {email: email}).then(() => {
      enqueueSnackbar(t('ForgotPwd.MessageSent'), {variant:'success', autoHideDuration: 5000});
      navigate("/login", { replace: true });
    }).catch(error => {
      log(error);
      enqueueSnackbar(t('ForgotPwd.RequestError'), {variant:'error', autoHideDuration: 5000});
      setWorking(false);
      setEmailInvalid(true);
    });
  }

  return (
    <PublicPage
      infoHeadline={t('ForgotPwd.InfoHeadline')}
      infoText={t('ForgotPwd.InfoText')}
      contentHeadline={t('ForgotPwd.FormHeadline')}
    >
      <form onSubmit={handleSubmit}>
        <TextField
          id="email"
          label={t('ForgotPwd.Email')}
          autoComplete="email"
          autoFocus
          required
          fullWidth
          error={emailInvalid}
          helperText={emailInvalid? t("ForgotPwd.EmailInvalid") : " "}
          onChange={(e) => {setEmail(e.target.value);setEmailInvalid(false);}}
        />
        <Button size="medium" className="public__link" onClick={() => navigate("/login", { replace: true })}>
          <Trans>ForgotPwd.BackToLogin</Trans>
        </Button>
        <Button
          type="submit"
          size="large"
          variant="contained"
          color="primary"
          working={working}
          className="public__submit"
        >
          <Trans>ForgotPwd.Button</Trans>
        </Button>
      </form>
    </PublicPage>
  );
}

export default PasswordRecoveryRequestPage;